module.exports = __webpack_public_path__ + "static/media/back-four.99d54ffc.png";